var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadersearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24,
    fill: "#FBFBFB",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7087 16.5C19.7274 16.5 16.5 19.6561 16.5 23.5494C16.5 27.4427 19.7274 30.5989 23.7087 30.5989C25.4114 30.5989 26.9763 30.0216 28.2097 29.0561L30.5528 31.3415L30.6151 31.394C30.8327 31.5514 31.1411 31.5335 31.3379 31.3405C31.5544 31.1282 31.554 30.7845 31.3369 30.5727L29.0214 28.3142C30.1987 27.0595 30.9173 25.3866 30.9173 23.5494C30.9173 19.6561 27.6899 16.5 23.7087 16.5ZM23.7077 17.5859C27.0757 17.5859 29.806 20.256 29.806 23.5496C29.806 26.8432 27.0757 29.5132 23.7077 29.5132C20.3397 29.5132 17.6094 26.8432 17.6094 23.5496C17.6094 20.256 20.3397 17.5859 23.7077 17.5859Z",
    fill: "#112347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadersearch);
export default __webpack_public_path__ + "static/media/headersearch.fb07f5a928f95b2da26c55d08637db7a.svg";
export { ForwardRef as ReactComponent };